export type FlowsTab = 'flows' | 'webhooks'
export type FlowTab = 'build' | 'history' | 'states'

export interface FlowsSearch {
  tab?: FlowsTab
}

export interface NewFlowSearch {
  /** Industry template id (`GET /flows/templates`). */
  template?: string
}

export interface FlowSearch {
  tab?: FlowTab
}

export function validateFlowsSearch(s: Record<string, unknown>): FlowsSearch {
  return s.tab === 'webhooks' || s.tab === 'flows' ? { tab: s.tab } : {}
}

export function validateNewFlowSearch(s: Record<string, unknown>): NewFlowSearch {
  return typeof s.template === 'string' && /^[a-z0-9_-]{1,64}$/i.test(s.template) ? { template: s.template } : {}
}

export function validateFlowSearch(s: Record<string, unknown>): FlowSearch {
  return s.tab === 'history' || s.tab === 'states' || s.tab === 'build' ? { tab: s.tab } : {}
}
